module.exports = __webpack_public_path__ + "img/aroma-benefit-plan.f9a93b09.svg";